// Sentry-Init fuer das Frontend.
// Liest DSN aus REACT_APP_SENTRY_DSN. Ohne DSN passiert nichts.
import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;
const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";
const release = process.env.REACT_APP_GIT_SHA || process.env.REACT_APP_VERSION || undefined;

if (dsn) {
  Sentry.init({
    dsn,
    environment: env,
    release,

    // Performance-Tracing: in Prod 10 %, lokal aus.
    tracesSampleRate: env === "production" ? 0.1 : 0,

    // Session-Replay nur fuer Errors (sparsam, GDPR-vertraeglicher).
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: env === "production" ? 0.5 : 0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Personenbezogene Daten maskieren.
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Bekannte Noise-Errors filtern.
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Network request failed", // mobile/online-toggle Noise
    ],

    // E-Mail / IP nicht senden.
    sendDefaultPii: false,
  });
  // eslint-disable-next-line no-console
  console.log("[sentry] frontend initialized for env=%s", env);
}
